import React, { Component } from 'react';
import Header from '../../Layout/Header'
import {Examples} from '../ContactUs/ContactUs'
import { Switch, Route } from 'react-router-dom'
import Wave from '../../Components/Wave'


import BushfireFront from './BushfireFront'
import HearthHouse from './HearthHouse'
import BunburyTurfClub from './BunburyTurfClub'
import CCIWA from './CCIWA'
import Churchview from './Churchview'
import Dalyellup from './Dalyellup'
import EnableWA from './EnableWA'
import MensHealthWA from './MensHealthWA'
import PrinceHotel from './PrinceHotel'
import VanMasters from './VanMasters'
import HarleyDykstra from './HarleyDykstra'
import Millard from './Millard'
import BusinessNews from './BusinessNews'
import BunburyCentral from './BunburyCentral'
import BunburyRunnersClub from './BunburyRunnersClub'
import LPC from './LPC'
import Koombana from './Koombana'
import Harvey from './Harvey'
import Picton from './Picton'
import WestCoastWaste from './WestCoastWaste'


class WhatWeveDone extends Component {
	render() {
		return (
			<div>
				<Switch>
<Route path={`${this.props.match.path}/West-Coast-Waste`} component={WestCoastWaste} />
				<Route path={`${this.props.match.path}/lpc`} component={LPC} />
					
					<Route path={`${this.props.match.path}/harvey-senior-high-school`} component={Harvey} />
					<Route path={`${this.props.match.path}/picton-trailer-hire`} component={Picton} />
					<Route path={`${this.props.match.path}/hearth-house`} component={HearthHouse} />
					<Route path={`${this.props.match.path}/bunbury-central`} component={BunburyCentral} />
					<Route path={`${this.props.match.path}/business-news`} component={BusinessNews} />
					<Route path={`${this.props.match.path}/bunbury-runners-club`} component={BunburyRunnersClub} />
					<Route path={`${this.props.match.path}/bunbury-turf-club`} component={BunburyTurfClub} />
					<Route path={`${this.props.match.path}/busfire-front`} component={BushfireFront} />
					<Route path={`${this.props.match.path}/cciwa-wa-works`} component={CCIWA} />
					<Route path={`${this.props.match.path}/churchview`} component={Churchview} />
					<Route path={`${this.props.match.path}/dalyellup-property-management`} component={Dalyellup} />
					<Route path={`${this.props.match.path}/enable-wa`} component={EnableWA} />
					<Route path={`${this.props.match.path}/mens-health-wa`} component={MensHealthWA} />
					<Route path={`${this.props.match.path}/prince-hotel`} component={PrinceHotel} />
					<Route path={`${this.props.match.path}/van-masters`} component={VanMasters} />
					<Route path={`${this.props.match.path}/harley-dykstra`} component={HarleyDykstra} />
					<Route path={`${this.props.match.path}/koombana-physiotherapy`} component={Koombana} />
					<Route path={`${this.props.match.path}/millard`} component={Millard} />
					<Route component={Page} />
				</Switch>
			</div>
		);
	}
}

const Page = () =>
	<div>
		<Header
			bg="#000000"
			title={"what we've done"}
			image={require('./background.jpg')}
			video={{ mp4: require('./video.mp4'), webm: require('./video.webm')}}
		/>
		<div className="entry-content page-case-study">
					<Examples />
					<section className="the-team ">
						<Wave className={`top over`} />
						<Wave className={`bottom over `} />
						<div className="container-fluid">
							<h2 className="outline text-center">
								<div className="line"></div>
								<div className="title">The moshi team and process</div>
							</h2>
							<div className="row">
								<div className="col-lg-2"></div>
								<div className="col-lg-8 text-center">
								<div className="tagline">
									“Moshi Moshi are experts at identifying who your best customers are and the best ways to reach them. Every business is different and we will custom plan a marketing strategy designed to help your business in facing its own set of unique challenges in your target area.  Helping start-ups through to long-established businesses, there are no cookie-cutter strategies here. One size does not fit all.”
								</div>
									<div className="author">
										<b>David Byatt, Moshi Director</b>
									</div>
								</div>
							</div>
							
						</div>
					</section>
		</div>
	</div>

export default WhatWeveDone;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/WhatWeveDone.js